export const CREATE_ORDER_TEMPLATE_BUTTON_TEXT = {
    id: 'oe.blueprints.orderTemplate.create.button',
    defaultMessage: '+ New Order Template',
    description: 'Button label',
};

export const NO_ORDER_TEMPLATES_TEXT = {
    id: 'oe.blueprints.noOrderTemplates',
    defaultMessage: 'No Order Templates have been created in this Account.',
    description: 'Placeholder text',
};

export const ORDER_TEMPLATE_TABLE_NAME_TEXT = {
    id: 'oe.blueprints.name',
    defaultMessage: 'Name',
    description: 'Label text'
};

export const ORDER_TEMPLATE_TABLE_DATE_CREATED_TEXT = {
    id: 'oe.blueprints.dateCreated',
    defaultMessage: 'Date Created',
    description: 'Label text'
};

export const ORDER_TEMPLATE_TABLE_DATE_MODIFIED_TEXT = {
    id: 'oe.blueprints.dateModified',
    defaultMessage: 'Date Modified',
    description: 'Label text'
};
